import { render, staticRenderFns } from "./TacticsTwo.vue?vue&type=template&id=d0009ff2&scoped=true"
import script from "./TacticsTwo.vue?vue&type=script&lang=js"
export * from "./TacticsTwo.vue?vue&type=script&lang=js"
import style0 from "./TacticsTwo.vue?vue&type=style&index=0&id=d0009ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0009ff2",
  null
  
)

export default component.exports